import { render, staticRenderFns } from "./ManifestComponentArguments.vue?vue&type=template&id=28ba0b20&scoped=true&"
import script from "./ManifestComponentArguments.vue?vue&type=script&lang=js&"
export * from "./ManifestComponentArguments.vue?vue&type=script&lang=js&"
import style0 from "./ManifestComponentArguments.vue?vue&type=style&index=0&id=28ba0b20&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28ba0b20",
  null
  
)

export default component.exports